import { HTMLProps } from 'react';
import * as S from './styles';

// Allow `any`s for awkward styled-components types
/* eslint @typescript-eslint/no-explicit-any: "off" */

export interface CheckboxProps extends HTMLProps<HTMLInputElement> {
  withCheckmark?: boolean;
  disabled?: boolean;
  ariaText: string;
  hasOverlay?: boolean;
}

const Checkbox = ({
  checked,
  className,
  as,
  ref,
  disabled,
  ariaText,
  withCheckmark = false,
  hasOverlay = false,
  ...rest
}: CheckboxProps) => {
  const checkbox = (
    <S.Checkbox
      aria-label={ariaText}
      type="checkbox"
      data-testid="checkbox-inner"
      checked={checked}
      ref={ref as any}
      as={as as any}
      $withCheckmark={withCheckmark}
      $hasOverlay={hasOverlay}
      disabled={disabled}
      {...rest}
    />
  );

  const checkboxElement = withCheckmark ? (
    <S.CheckboxContainerWithCheckmark
      aria-label={ariaText}
      className={className}
      $checked={checked as boolean}
      $disabled={disabled}
      $hasOverlay={hasOverlay}
      data-testid="checkbox-with-checkmark"
    >
      {checkbox}
    </S.CheckboxContainerWithCheckmark>
  ) : (
    <S.CheckboxContainer
      aria-label={ariaText}
      className={className}
      $checked={checked as boolean}
      data-testid="checkbox-without-checkmark"
    >
      {checkbox}
    </S.CheckboxContainer>
  );

  return hasOverlay ? (
    <S.CheckboxOverlay data-testid="checkbox-overlay">{checkboxElement}</S.CheckboxOverlay>
  ) : (
    checkboxElement
  );
};

export default Checkbox;
